import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';
import useStripeConnectOnboarding from '../../hooks/useStripeConnectOnboarding';
import StripeOnboardingNoticeModal from './StripeOnboardingNoticeModal';
import styles from './Payments.module.css';

const PaymentSetupCard = () => {
  const { jeweller } = useAuth();
  const isConnected = jeweller?.stripe?.status && jeweller.stripe.status === "connected";
  const {
    isLoading,
    isNoticeOpen,
    openNotice,
    closeNotice,
    continueToStripe
  } = useStripeConnectOnboarding();

  return (
    <>
      <div className={styles.setupCard}>
        <div className={styles.setupIconWrapper}>
          <ExclamationTriangleIcon className={styles.setupIcon} />
        </div>
        
        <h3 className={styles.setupTitle}>Get Started With Payments</h3>
        <p className={styles.setupDescription}>
          Connect Stripe once to enable sending invoices and receiving payments.
        </p>
        <p className={styles.setupImportantNote}>
          Important: create a new Stripe account for Boutee only. Do not link an existing Stripe account that you already use elsewhere.
        </p>
        
        <div className={styles.setupActions}>
          {isConnected ? (
            <span className={styles.setupStatus}>Connected</span>
          ) : (
            <button className={styles.setupButton} onClick={openNotice} disabled={isLoading}>
              {isLoading ? 'Opening Stripe...' : 'Connect Stripe'}
            </button>
          )}
        </div>
      </div>

      <StripeOnboardingNoticeModal
        isOpen={isNoticeOpen}
        onClose={closeNotice}
        onContinue={continueToStripe}
        isSubmitting={isLoading}
      />
    </>
  );
};

export default PaymentSetupCard;
